<template>
    <v-container class="mb-6">

        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>

        <!-- <v-card class="elevation-2 mt-5 mb-8">
            <v-card-title class="flex-nowrap">
                Filtros
            </v-card-title>
            <v-card-text>
                <form @submit.prevent="processSearch">
                    <v-row align="center">
                        <v-col cols="12" sm="6">
                            <v-text-field
                                v-model="txtSearch"
                                label="Buscar por nombre"
                                outlined
                                dense
                                hide-details
                                type="text"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field
                                v-model="txtPhone"
                                label="Buscar por celular"
                                outlined
                                dense
                                hide-details
                                type="text"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <div class="text-right mt-8">
                        <v-btn
                            color="primary"
                            type="submit"
                        >
                            Buscar
                        </v-btn>
                        <v-btn
                            color="red"
                            text
                            @click="cleanSearch"
                            v-show="(txtSearch !== '') || (txtPhone!='')"
                        >
                            Limpiar
                        </v-btn>
                    </div>
                </form>
            </v-card-text>
        </v-card> -->

        <!-- card main -->
        <v-card class="elevation-2 mt-5">
            <v-card-title class="blue-grey darken-4 white--text">
                Lista de clientes
                <v-spacer></v-spacer>
                <v-btn
                    class="text-capitalize mb-2 mb-sm-0 mr-2"
                    :href="`/admin/export-clients?name=${txtSearch}&phone=${txtPhone}&sales=${txtSales}&salesTotal=${txtSalesTotals}&ticket=${txtTicket}`"
                >
                    <v-icon class="mr-2" color="green">mdi-file-excel</v-icon>
                    Exportar
                </v-btn>
            </v-card-title>

            <v-simple-table>
                <template v-slot:default>
                <thead>
                    <tr>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>Nombre</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='full_name', getListClients()"
                                            ></span>
                                        </template>
                                        <span>Orden descendente</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='full_name', getListClients()"
                                            ></span>
                                        </template>
                                        <span>Orden ascendente</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtSearch"
                                                    label="Buscar por nombre"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="text"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('txt')"
                                                    >
                                                        Limpiar
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>Celular</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='phone_number', getListClients()"
                                            ></span>
                                        </template>
                                        <span>Orden descendente</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='phone_number', getListClients()"
                                            ></span>
                                        </template>
                                        <span>Orden ascendente</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtPhone"
                                                    label="Buscar por celular"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="text"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('phone')"
                                                    >
                                                        Limpiar
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>Número de ventas</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='order_count', getListClients()"
                                            ></span>
                                        </template>
                                        <span>Orden descendente</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='order_count', getListClients()"
                                            ></span>
                                        </template>
                                        <span>Orden ascendente</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtSales"
                                                    label="Buscar por ventas"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="text"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('sales')"
                                                    >
                                                        Limpiar
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>Ventas totales en {{ money }}</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='total', getListClients()"
                                            ></span>
                                        </template>
                                        <span>Orden descendente</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='total', getListClients()"
                                            ></span>
                                        </template>
                                        <span>Orden ascendente</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtSalesTotals"
                                                    label="Buscar por ventas totales"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="text"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('salestotal')"
                                                    >
                                                        Limpiar
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-right">
                            <div class="d-flex align-center">
                                <span>Ticket prom de ventas en {{ money }}</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='ticket', getListClients()"
                                            ></span>
                                        </template>
                                        <span>Orden descendente</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='ticket', getListClients()"
                                            ></span>
                                        </template>
                                        <span>Orden ascendente</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtTicket"
                                                    label="Buscar por ticket"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="text"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('ticket')"
                                                    >
                                                        Limpiar
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-right">
                            <div class="d-flex align-end">
                                <span>Puntos de fidelidad</span>
                                <div class="wrap-order">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='points', getListClients()"
                                            ></span>
                                        </template>
                                        <span>Orden descendente</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='points', getListClients()"
                                            ></span>
                                        </template>
                                        <span>Orden ascendente</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtPoints"
                                                    label="Buscar por puntos de fidelidad"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="text"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('points')"
                                                    >
                                                        Limpiar
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in listClients" :key="index">
                        <td>{{ item.full_name }}</td>
                        <td>{{ item.phone_number }}</td>
                        <td>{{ item.order_count }}</td>
                        <td>{{ item.total }}</td>
                        <td>{{ ((+item.total)/(+item.order_count)).toFixed(2) }}</td>
                        <td class="text-right">{{ (item.points).toFixed(0) }}</td>
                    </tr>
                </tbody>
                </template>
            </v-simple-table>
        </v-card>
        <div class="text-right py-2" v-html="pageTable"></div>
        <v-pagination
            v-model="page"
            :length="totalPage"
            :total-visible="5"
            color="primary"
            @input="changePage"
            class="my-5"
        ></v-pagination>
        <!-- end card main -->

        <!-- overlay -->
        <v-overlay :value="overlay" opacity=".9" z-index="10">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay>
        <!-- end overlay -->

    </v-container>
</template>
<script>
export default {
    data() {
        return {
            overlay: false,
            loading: false,
            breadcrumbs: [
                {
                    text: 'Clientes',
                    disabled: false,
                    href: '/admin/clients',
                },
                {
                    text: 'Todos',
                    disabled: true,
                    href: '',
                }
            ],
            tmpSlug: 'http://'+window.location.hostname+'/',
            // list data
            listClients: [],
            pageTable: '',
            page: 1,
            totalPage: null,
            txtSearch: '',
            txtPhone: '',
            txtSales: '',
            txtSalesTotals: '',
            txtTicket: '',
            txtPoints: '',
            orderType: 'DESC',
            orderBy: 'created_at'
        }
    },
    props: ['money'],
    mounted() {
        this.getListClients()
    },
    methods: {
        /**
         * List categories
         */
        processSearch () {
            this.page = 1
            this.getListClients()
        },
        changePage (event) {
            this.page = event;
            this.getListClients()
        },
        cleanSearch (type='') {
            if (type=='') {
                if ( (this.txtSearch !== '') || (this.txtPhone!='') ) {
                    this.listClients = []
                    this.page = 1
                    this.txtSearch = ''
                    this.txtPhone = ''
                    this.getListClients();
                }
            } else {
                switch (type) {
                    case 'txt':
                        this.txtSearch = ''
                        this.getListClients();
                        break;
                    case 'phone':
                        this.txtPhone = ''
                        this.getListClients();
                        break;
                    case 'sales':
                        this.txtSales = ''
                        this.getListClients();
                        break;
                    case 'salestotal':
                        this.txtSalesTotals = ''
                        this.getListClients();
                        break;
                    case 'ticket':
                        this.txtTicket = ''
                        this.getListClients();
                        break;
                    case 'points':
                        this.txtPoints = ''
                        this.getListClients();
                        break;
                    default:
                        break;
                }
            }
        },
        async getListClients () {
            this.listClients = []
            this.overlay = true
            await axios.post(`/admin/list-clients?page=${this.page}
                            &orderby=${this.orderBy}
                            &ordertype=${this.orderType}
                            &search=${this.txtSearch}
                            &phone=${this.txtPhone}
                            &sales=${this.txtSales}
                            &salestotal=${this.txtSalesTotals}
                            &ticket=${this.txtTicket}
                            &points=${this.txtPoints}
                        `, {})
            .then(response => {
                // console.log(response)
                response.data.data.forEach(element => {
                    const d = new Date(element.created_at)
                    element.date = d.getDate() +'-'+ (d.getMonth()+1) +'-'+ d.getFullYear() +'  '+ d.getHours()+':'+d.getMinutes()
                    this.listClients.push(element)
                });
                // this.listClients = response.data.data
                this.totalPage = response.data.last_page
                this.pageTable = `Mostrando <strong>${response.data.from??0} - ${response.data.to??0}</strong> de un total de <strong>${response.data.total}</strong>`
                this.overlay = false
            })
            .catch(error => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.overlay = false
            })
        },
    },
}
</script>
